module.exports = "/_next/static/images/donate-6e96a55003fb29a6fbfd03b2b4191e06.png";